module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "d-flex flex-column overflow-visible",
    class: [{
      'collapsed': !_vm.isHoveringMenu
    }],
    on: {
      "mouseenter": _vm.mouseenter,
      "mouseleave": _vm.mouseleave
    }
  }, [_c('nav', {
    staticClass: "flexGrow1",
    attrs: {
      "role": "navigation"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('div', {
    staticClass: "logoCanvas"
  }, [_c('img', {
    staticClass: "logoBig",
    attrs: {
      "src": require("../../assets/images/logo.svg"),
      "alt": "Pluralo"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "logoSmall",
    attrs: {
      "src": "/static/images/common/logo_small_red_white.svg",
      "alt": "Pluralo"
    }
  })]), _vm._v(" "), _c('ul', [_vm._l((_vm.linksNew), function(link, index) {
    return [(link.linkTo === 'settings' && _vm.showThisLink(link)) ? _c('li', {
      key: 'divider-' + index,
      staticClass: "navDivider",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.showThisLink(link)) ? _c('li', {
      key: index,
      staticClass: "position-relative no-break-label"
    }, [_c('router-link', {
      attrs: {
        "exact": "",
        "active-class": "active",
        "to": {
          name: link.linkTo
        }
      }
    }, [_c('span', {
      staticClass: "selection"
    }), _vm._v(" "), _c('span', {
      staticClass: "iconHolder"
    }, [_c('i', {
      class: link.icon
    }), _vm._v(" "), (_vm.showNewLabel(link)) ? _c('span', {
      staticClass: "newItemLabel fs-smallest bg-color-1"
    }, [_vm._v("New")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(link.label))])])], 1) : _vm._e()]
  })], 2)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3a5eeca4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5eeca4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Sidebar.vue
// module id = 2393
// module chunks = 0